export default ($resource) => {
    const url = `${SEED_CORE.ENV.API_URL}site/site/:id`;

    return $resource(url, null, {
        update: {
            method: 'PUT',
            url
        },
        delete: {
            method: 'DELETE',
            url
        },
        setUserRoles: {
            method: 'POST',
            url: `${url}/set-user-roles`
        },
        userSites: {
            method: 'GET',
            url: `${url}/user-sites`,
            isArray: true
        },
        indexTree: {
            method: 'GET',
            url: `${url}/index-tree`,
            isArray: true
        }
    });
};



// WEBPACK FOOTER //
// ./src/app/resources/Site/index.js